import { QueryClient } from "@tanstack/react-query"
import type * as Api from "../@client/api"

export function getTypedQueryData<ActionName extends keyof Api.GET>(
  queryClient: QueryClient,
  url: ActionName,
  input: Api.Input[ActionName]
) {
  return queryClient.getQueryData<Api.Output[ActionName]>([url, input])
}
